import React, { useState } from "react";
import "../Styles/BlurImage.scss";

const BlurImage = ({ src, alt, className = "", style = {}, imgClassName = "", ...props }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`blur-image-wrapper ${loaded ? "is-loaded" : "is-loading"} ${className}`} style={style}>
      <div className="blur-image-placeholder-shimmer" />
      <img
        src={src}
        alt={alt || "Image"}
        className={`blur-image-real ${loaded ? "loaded" : "loading"} ${imgClassName}`}
        onLoad={() => setLoaded(true)}
        {...props}
      />
    </div>
  );
};

export default BlurImage;
